const USER = {}
USER.id = document.getElementById('wpcb_current_user').value
export default USER